<script lang="ts">
	import { IS_AQUEDUCT } from '$lib/site';
	import IliadLanding from '$components/landing/IliadLanding.svelte';
	import AqueductLanding from '$components/landing/AqueductLanding.svelte';
</script>

{#if IS_AQUEDUCT}
	<AqueductLanding />
{:else}
	<IliadLanding />
{/if}
